import { datadogLogs } from '@datadog/browser-logs';
import { formatLogMessage } from './errorReporting';
import { getApiAxiosInstance } from './network';
import { validateUSAPId } from '../api/tmsEventsApi';

const ShortErrorMsgs = {
    InvalidId: 'You have entered in invalid member ID.',
    GeneralError: 'There was an error validating your member ID.',
    ExpiredId: 'Your USAP membership is expired.',
    ExpiringId: 'Your USAP membership will expire before the end of the tournament.',
    Suspended: 'Your USAP membership is suspended.',
    InvalidUsapMembershipTier: 'Your USAP membership tier does not qualify for this tournament.',
    NameMismatch: 'Your UTR account name does not match the provided USAP member account.',
    PartnerNameMismatch: 'Your partner\'s UTR account name does not match the provided USAP member account.',
};

export const createValidateUsapIdCallback = (jwt, eventId, name) => async (usapId) => {
    const isFormatValid = /^\d+$/.test(usapId);
    if (!isFormatValid) {
        return { error: 'Please provide a numeric ID.' };
    }

    try {
        const result = await validateUSAPId(getApiAxiosInstance(jwt), eventId, { usapId, name });
        return {
            error: result.data.valid ? null : result.data.message,
        };
    } catch (e) {
        datadogLogs.logger.error(
            formatLogMessage('usap', 'USAP id validation failed', { eventId, usapId }),
            { eventId, usapId },
            e,
        );

        return {
            error: 'Error validating USAP ID. For further assistance, please contact the tournament organizer.',
        };
    }
};

function extractErrorCodeFromErrorMessage(errorMessage) {
    if (!errorMessage) {
        return null;
    }

    const errorCodeMatch = errorMessage.match(/ErrorCode: (.*),\s*UsapMemberId/);
    if (!errorCodeMatch) {
        return null;
    }

    const codeMatch = errorCodeMatch[0]?.match(/ErrorCode: ([^,]+)/);
    return codeMatch && codeMatch.length > 1 ? codeMatch[1].trim() : null;
}

// Returns a short (non-HTML) error message for the USAP ID validation error object
export const getUsapMessageFromError = (error) => {
    const errorMessage = error?.response?.data?.Message;
    const errorCode = extractErrorCodeFromErrorMessage(errorMessage);

    return errorCode && ShortErrorMsgs[errorCode];
};
